import { JsonObject, JsonProperty } from 'json2typescript';
import { SearchResults } from '../searchResults';
import { Charter } from './charter';

@JsonObject('CharterSearchResults')
export class CharterSearchResults extends SearchResults {
    @JsonProperty('results', [Charter])
    results: Charter[] = [];
}
